import React, { Component } from 'react'
import "./policySearch.scss"
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'
import { getApiPfindWithPager , getApiGetAllIndustry , getApiGetAreaList , getApiGetDeptList , getApiGetAcademicLevel , getApiGetAllPartition , getApiGetAllChaPlate } from "../../axios/api"
import { Pagination , Cascader, message } from 'antd';
import 'antd/dist/antd.css';
import { remove , get } from '../../axios/localstorage'


export default class policySearch extends Component {


    state = {
        banner:[],
        list:[],

        currentIndex:0,
        nIndex:0,

        newsType:1,

        page:1,
        total:0,

        key:"",

        showMore:false,

        name:"",
        area:"",
        areaName:"",
        areaList:[],
        dept:"",
        deptName:"",
        deptList:[],
        attributes:"",
        industries:"",
        industriesName:"",
        industriesList:[],
        attributesName:"",
        attributesList:[],
    }

    componentWillMount(){

        let name = get('name');
        if(name){
            this.setState({
                name
            })

            remove('name')
        }
        

        getApiGetAcademicLevel()
        .then( req =>{
            if(req.data.code === 1){

            }
        }).catch( err =>{
            console.error(err);
        })
        getApiGetAllPartition()
        .then( req =>{
            if(req.data.code === 1){

                let data = req.data.data;

                this.setState({
                    attributesList:data
                })

            }
        }).catch( err =>{
            console.error(err);
        })

        getApiGetAllIndustry()
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                if(data){
                    this.setState({
                        industriesList:data
                    })
                }
            }
        }).catch( err =>{
            console.error(err);
        })
        getApiGetAreaList({area:"RegisterArea_HDDQ_Jiangsu_NanJin"}) //RegisterArea_HDDQ_Jiangsu_NanJin RegisterArea_ZXS_Beijing
        .then( req =>{
            if(req.data.code === 1){

                let data = req.data.data;
                // console.log(data.splice(3,data.length));
                if(data){
                    this.setState({
                        areaList:data.splice(3,data.length),
                        // area:data[3].areaCode
                    })
                }

                // this.getDept();
            }
        }).catch( err =>{
            console.error(err);
        })
        // getApiGetDeptList({area:"RegisterArea_HDDQ_Jiangsu_NanJin"}) //RegisterArea_HDDQ_Jiangsu_NanJin RegisterArea_ZXS_Beijing
        // .then( req =>{
        //     if(req.data.code === 1){
        //         let data = req.data.data;
        //         if(data){
        //             this.setState({
        //                 deptList:data
        //             })
        //         }
        //     }
        // }).catch( err =>{
        //     console.error(err);
        // })
        getApiGetAllChaPlate()
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                if(data){
                    this.setState({
                        plateList:data,
                    })
                }
            }
        }).catch( err =>{
            console.error(err);
        })
    }

    componentDidMount(){
        window.scroll(0,0);
        // getApiBanner({type:2})
        // .then( req =>{
        //     if(req.data.code === 1){
        //         this.setState({
        //             banner:req.data.data
        //         })
        //     }
        // }).catch( err =>{
        //     console.error(err);
        // })
        // this.getList();
    }

    onChange=(index)=>{
        this.setState({
            currentIndex:index
        })
    }

    getDept=()=>{
        setTimeout(()=>{
            getApiGetDeptList({area:this.state.area}) //RegisterArea_HDDQ_Jiangsu_NanJin RegisterArea_ZXS_Beijing
            .then( req =>{
                if(req.data.code === 1){
                    let data = req.data.data;
                    if(data){
                        this.setState({
                            deptList:data
                        })
                    }
                }
            }).catch( err =>{
                console.error(err);
            })

            // this.changePage(1)
        },20)
    }

    changePage=(page)=>{
        this.setState({
            page
        })

        console.log(999)

        setTimeout(()=>{
            this.getList();
        },50)
    }

    gotoSlide=(num)=>{
        this.refs['bslide'].goTo(num);
    }

    gotoPage=(page)=>{
        this.props.history.push(page);
    }

    getList=()=>{
        let param = {
            page:this.state.page,
            area:this.state.area,
            dept:this.state.dept,
            industries:this.state.industries,
            attributes:this.state.attributes,
            searchKey:this.state.name,
        }

        getApiPfindWithPager(param)
        .then( req =>{
            if(req.data.code === 1){

                let data = req.data.data;
                this.setState({
                    list:data.rows,
                    total:data.total
                })

            }else{
                message.info(req.data.msg);
            }
        }).catch( err =>{
            console.error(err);
        })
    }



    render() {
        return (
            <div className='policySearch'>
                <Header type={2} />
                <div className='head'>
                    <div className='cen'>
                        <div className='hmain'>
                            <div className='hname'>
                                <p>当前位置：</p>
                                <p className='i_point' onClick={()=>{this.gotoPage('/')}}>首页</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p>政策查询</p>
                            </div>
                            
                            <div className='hbox'>
                                <div className='hitem'>
                                    <h2>项目名称</h2>
                                    <div className='hipt'>
                                        <input type="text" placeholder='' value={this.state.name} onChange={(ev)=>{this.setState({name:ev.target.value})}} />
                                    </div>
                                </div>
                                <div className='hitem'>
                                    <h2>项目类型标签</h2>
                                    <div className='hipt'>
                                        <h2>{this.state.attributesName}</h2>
                                        <div className="casDiv">
                                            <Cascader  fieldNames={{ label: 'fullName', value: 'value' }} 
                                            style={{borderColor:'#fff',flex:'1',opacity:'0',width:"100%"}} 
                                            placeholder=' ' size="large" options={this.state.attributesList} 
                                            onChange={(value,selectedOptions)=>{
                                                console.log(value);
                                                console.log(selectedOptions)
                                                let data = selectedOptions[0];
                                                if(data){
                                                    this.setState({
                                                        attributes:data.value,
                                                        attributesName:data.fullName
                                                    })
                                                }
                                            }} />
                                        </div>
                                        <div className={this.state.attributesName?'himg himg2':'himg'}>
                                            <img className='hicon' alt="" src="/www/assets/imgs/xiala-neirong.png" />
                                            <img className='hicon2' onClick={()=>{this.setState({attributes:"",attributesName:""})}} alt="" src="/www/assets/imgs/close4.png" />
                                        </div>
                                    </div>
                                </div>
                                <div className='hitem'>
                                    <h2>地区</h2>
                                    <div className='hipt'>
                                        <h2>{this.state.areaName}</h2>
                                        <div className="casDiv">
                                            <Cascader fieldNames={{ label: 'areaName', value: 'areaCode' }} 
                                            style={{borderColor:'#fff',flex:'1',opacity:'0',width:"100%"}} 
                                            placeholder=' ' size="large" options={this.state.areaList} 
                                            onChange={(value,selectedOptions)=>{
                                                console.log(value);
                                                console.log(selectedOptions)
                                                let data = selectedOptions[0];
                                                this.setState({
                                                    area:data.areaCode,
                                                    areaName:data.areaName
                                                })

                                                this.getDept();
                                            }} />
                                        </div>
                                        <div className={this.state.areaName?'himg himg2':'himg'}>
                                            <img className='hicon' alt="" src="/www/assets/imgs/xiala-neirong.png" />
                                            <img className='hicon2' onClick={()=>{this.setState({areaName:"",area:""})}} alt="" src="/www/assets/imgs/close4.png" />
                                        </div>
                                    </div>
                                </div>
                                <div className='hitem'>
                                    <h2>受理部门</h2>
                                    <div className='hipt'>
                                        <h2>{this.state.deptName}</h2>
                                        <div className="casDiv">
                                            <Cascader  fieldNames={{ label: 'deptName', value: 'deptID' }} 
                                            style={{borderColor:'#fff',flex:'1',opacity:'0',width:"100%"}} 
                                            placeholder=' ' size="large" options={this.state.deptList} 
                                            onChange={(value,selectedOptions)=>{
                                                console.log(value);
                                                console.log(selectedOptions)
                                                let data = selectedOptions[0];
                                                if(data){
                                                    this.setState({
                                                        deptName:data.deptName,
                                                        dept:data.deptID
                                                    })
                                                }
                                            }} />
                                        </div>
                                        <div className={this.state.dept?'himg himg2':'himg'}>
                                            <img className='hicon' alt="" src="/www/assets/imgs/xiala-neirong.png" />
                                            <img className='hicon2' onClick={()=>{this.setState({dept:"",deptName:""})}} alt="" src="/www/assets/imgs/close4.png" />
                                        </div>
                                    </div>
                                </div>
                                <div className='hitem'>
                                    <h2>产业类别</h2>
                                    <div className='hipt'>
                                        <h2>{this.state.industriesName}</h2>
                                        <div className="casDiv">
                                            <Cascader  fieldNames={{ label: 'fullName', value: 'value' }} 
                                            style={{borderColor:'#fff',flex:'1',opacity:'0',width:"100%"}} 
                                            placeholder=' ' size="large" options={this.state.industriesList} 
                                            onChange={(value,selectedOptions)=>{
                                                console.log(value);
                                                console.log(selectedOptions)
                                                let data = selectedOptions[0];
                                                if(data){
                                                    this.setState({
                                                        industriesName:data.fullName,
                                                        industries:data.fullName
                                                    })
                                                }
                                            }} />
                                        </div>
                                        <div className={this.state.industriesName?'himg himg2':'himg'}>
                                            <img className='hicon' alt="" src="/www/assets/imgs/xiala-neirong.png" />
                                            <img className='hicon2' onClick={()=>{this.setState({industries:"",industriesName:""})}} alt="" src="/www/assets/imgs/close4.png" />
                                        </div>
                                    </div>
                                </div>
                                {/* <div className='hitem'>
                                    <h2>申报条件</h2>
                                    <div className='hipt'>
                                        <img className='hicon' alt="" src="/www/assets/imgs/xiala-neirong.png" />
                                    </div>
                                </div>
                                
                                <div className='hitem'>
                                    <h2>支持标准</h2>
                                    <div className='hipt'>
                                        <img className='hicon' alt="" src="/www/assets/imgs/xiala-neirong.png" />
                                    </div>
                                </div>
                                <div className='hitem'>
                                    <h2>申报时间</h2>
                                    <div className='hipt'>
                                        <img className='hicon' alt="" src="/www/assets/imgs/xiala-neirong.png" />
                                    </div>
                                </div> */}
                                <div className='hitem'>
                                    <h2>{}</h2>
                                    <button className='hbtn' onClick={()=>{this.changePage(1)}}>快速查询</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='hnum'>
                    <div className='cen'>
                        <div className='hmain'>
                            {/* <div className='htype'>
                                <div className='ht1 chosen'>全部</div>
                                <div className='ht2'>最近7天内截止</div>
                                <div className='ht3'>最近30天内截止</div>
                            </div> */}

                            <h4>共查找到<span>{this.state.total}</span>条信息</h4>
                        </div>
                    </div>
                </div>

                <div className='hpage'>
                    <div className='cen'>
                        <div className='hmain'>
                            <table>
                                <thead>
                                    <tr className='trh'>
                                        <th className='tfd'>项目名称</th>
                                        <th>项目来源</th>
                                        <th>星极</th>
                                        <th>申报时间</th>
                                        {/* <th>结束倒计时</th> */}
                                    </tr>
                                    <tr className='trh2'>
                                        <th></th>
                                        <th></th>
                                        {/* <th></th> */}
                                    </tr>
                                </thead>
                                
                                <tbody>
                                    {
                                        this.state.list.map((item,index)=>{
                                            return <tr key={index} onClick={()=>{this.gotoPage('/policySearchInfo?id='+item.id)}}>
                                                        <td className='tfd'>{item.title}</td>
                                                        <td>{item.dept}</td>
                                                        <td className='tstar'>
                                                            <div className='tflex'>
                                                                <img hidden={item.levelStar.length < 1} className='star' alt='' src="/www/assets/imgs/star.png" />
                                                                <img hidden={item.levelStar.length < 2} className='star' alt='' src="/www/assets/imgs/star.png" />
                                                                <img hidden={item.levelStar.length < 3} className='star' alt='' src="/www/assets/imgs/star.png" />
                                                                <img hidden={item.levelStar.length < 4} className='star' alt='' src="/www/assets/imgs/star.png" />
                                                                <img hidden={item.levelStar.length < 5 } className='star' alt='' src="/www/assets/imgs/star.png" />
                                                            </div>
                                                        </td>
                                                        <td>{item.time}</td>
                                                        {/* <td className='tdw'>
                                                            <div className='tflex'>
                                                                <div className='tbtn'>0天</div>
                                                            </div>
                                                        </td> */}
                                                    </tr>
                                        })
                                    }
                                </tbody>
                            </table>
                            <div className='r_page'>
                                <Pagination type="success" showSizeChanger={false} pageSize={10}  current={this.state.page} total={this.state.total} onChange={(page)=>{this.changePage(page)}} />
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
